<template>
  <div class="dialog-wrapper">
    <div class="dialog-content" :style="{ 'width': '815px' }">
      <img class="dialog-icon" src="@/profile/assets/icons/dialog-warning.svg" alt="">
      <h3 class="img-center item-m">Продолжите вход</h3>
      <p class="title">
        К сожалению, мы не смогли вас идентифицировать. Если Вам
        необходимо подать документы в компанию, пожалуйста, выполните
        вход, пройдя по ссылке:
      </p>
      <div class="links">
        <a href="https://makclife.ru/statements/" class="text-link">Сервис подачи заявления для не страхователей</a>
        <a href="https://makclife.ru/profile/" class="text-link">На страницу авторизации</a>
      </div>

    </div>
  </div>
  <div>
  </div>
</template>

<style>
.links{
  margin-bottom: 50px;
}
.links a{
  margin-bottom: 5px;
  display: block;
  padding: 5px;
}
.img-center {
  margin: 0px auto;
}
.item-m {
  margin-top: 26px;
  margin-bottom: 12px;
}
.text-link {
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  color: #005fad;
  cursor: pointer;
}
.title {
  text-align: center;
  padding: 4px 12px 16px 12px;
  font-size: 22px;
  font-weight: 500;
  color: #6b7280;
  @media (max-width: 700px) {
    font-size: 16px;
  }
}
.p-54 {
  padding: 54px;
  @media (max-width: 700px) {
    padding: 24px;
  }
}
</style>
<script setup lang="ts">
</script>